import { Component, OnInit, DestroyRef } from '@angular/core';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@app/core';

@Component({
  selector: 'app-dashboard-chart1',
  templateUrl: './dashboard-chart1.component.html',
  styleUrls: ['./dashboard-chart1.component.scss'],
  standalone: true,
  imports: [CommonModule, BaseChartDirective, TranslateModule]
})
export class DashboardChart1Component implements OnInit {
  constructor(
    private service: DashboardService,
    private toArabic: ToArabicPipe,
    private languageService: LanguageService,

    private destroyRef: DestroyRef
  ) {}

  loaded: boolean;
  lineChartPlugins = [ChartDataLabels];
  lineChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        data: [],
        label: '',
        yAxisID: 'A',
        borderColor: 'black',
        backgroundColor: 'rgb(93,98,181)',
        datalabels: {
          display: false
        }
      }
    ]
  };

  lineChartOptions: ChartConfiguration['options'] = {};
  lineChartType: ChartType = 'bar';

  getData() {
    this.service
      .getData('today-contractors-info')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((data: any) => data.data),
        map((data: any) => this.refactorResponse(data))
      )
      .subscribe((response: any) => {
        this.lineChartData.labels = response.map((data: any) => data['contractor_name']).reverse();
        this.lineChartData.datasets[0].data = response.map((data: any) => data['total_weights']).reverse();
        this.loaded = true;
      });
  }

  refactorResponse = (response: any) => response;

  ngOnInit() {
    this.setOptions();
    this.getData();
  }

  changeFontSizeOnSmallScreen() {
    return window.innerWidth <= 1366 ? 10 : 12;
  }

  setOptions() {
    this.lineChartOptions = {
      responsive: true,
      plugins: {
        tooltip: {
          backgroundColor: '#5D62B5',
          titleAlign: 'center',
          titleFont: {
            size: 16,
            family: 'Helvetica'
          },
          padding: {
            top: 0,
            right: 6,
            bottom: 0,
            left: 6
          },
          displayColors: false,
          callbacks: {
            title: (tooltipItems: any) => {
              const item = tooltipItems[0];
              return `${item.label}\nالوزن : ${this.toArabic.transform(item.parsed.y.toString())} طن`;
            },
            label: () => '' // Remove label body
          }
        },
        legend: {
          display: false
        }
      },
      scales: {
        A: {
          position: 'right'
        },
        x: {
          ticks: {
            display: true,
            font: {
              size: this.changeFontSizeOnSmallScreen()
            },
            autoSkip: false
          }
        }
      }
    };
  }

  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}
